module.exports = __webpack_public_path__ + "static/media/bitmap-11@3x.c470ee40.jpg";